import FetchUtils from 'src/utils/fetch_utils';
import LayoutUtils from 'src/utils/layout_utils';

class EditFormDependencies {
  static getFormElements(form) {
    return {
      listingSelect: form.querySelector('.js-showing-view-listing-select'),
      teamMemberSelect: form.querySelector('.js-showing-view-team-member-select'),
      showtimeTypeSelect: form.querySelector('.js-showing-view-showtime-type'),
      confirmationTypeSelect: form.querySelector('.js-showing-view-confirmation-type'),
      acceptWrap: form.querySelector('.js-showing-view-accept-wrap')
    };
  }

  static buildParams(elements) {
    const params = new URLSearchParams();
    if (elements.listingSelect?.value) params.append('showing[listing_id]', elements.listingSelect.value);
    if (elements.teamMemberSelect && !elements.teamMemberSelect.disabled) {
      params.append('showing[team_member_id]', elements.teamMemberSelect.value);
    }
    if (elements.showtimeTypeSelect?.value) params.append('showtime_type', elements.showtimeTypeSelect.value);
    return params;
  }

  static applyShowtimeTypeOptions(select, optionsHtml) {
    if (!select || !optionsHtml) return;
    const previousType = select.value;
    select.innerHTML = optionsHtml;
    if (previousType && select.querySelector(`option[value="${previousType}"]`)) {
      select.value = previousType;
    }
  }

  static applyTeamMemberOptions(select, optionsHtml) {
    if (!select || !optionsHtml) return;
    const prevValue = select.value;
    select.innerHTML = optionsHtml;
    if (prevValue !== undefined && prevValue !== null && select.querySelector(`option[value="${prevValue}"]`)) {
      select.value = prevValue;
    }
  }

  static applyConfirmationOptions(select, optionsHtml) {
    if (!select || !optionsHtml) return;
    select.innerHTML = optionsHtml;
  }

  static applyAcceptedVisibility(acceptWrap, response) {
    if (acceptWrap) {
      LayoutUtils.toggle(acceptWrap, response.accepted_visible);
    }
  }

  static replaceTimeSection(form, timeFormHtml, callbacks) {
    if (!timeFormHtml) return;
    const currentTimeWrap = form.querySelector('.js-showing-view-time-section');
    if (!currentTimeWrap) return;
    const nextWrap = document.createElement('div');
    nextWrap.innerHTML = timeFormHtml;
    const replacement = nextWrap.firstElementChild;
    if (replacement) {
      currentTimeWrap.replaceWith(replacement);
      document.dispatchEvent(new CustomEvent('html-updated', {
        detail: { container: '.js-showing-view-time-section', keepOpened: true }
      }));
      callbacks.onTimeSectionReplaced?.(form);
    }
  }

  static applyResponse(form, response, elements, callbacks) {
    if (!response.success) return;

    EditFormDependencies.applyShowtimeTypeOptions(elements.showtimeTypeSelect, response.showtime_type_options_html);
    EditFormDependencies.applyTeamMemberOptions(elements.teamMemberSelect, response.team_members_html);
    EditFormDependencies.applyConfirmationOptions(elements.confirmationTypeSelect, response.confirmation_options_html);
    EditFormDependencies.applyAcceptedVisibility(elements.acceptWrap, response);
    EditFormDependencies.replaceTimeSection(form, response.time_form_html, callbacks);
    callbacks.refreshLucideIcons?.();
  }

  /**
   * Callbacks: refreshLucideIcons(), onTimeSectionReplaced(form) — called after replacing time section HTML to re-init it.
   */
  static reload(form, callbacks = {}) {
    const dependenciesUrl = form.dataset.dependenciesUrl;
    if (!dependenciesUrl) {
      return;
    }

    const elements = EditFormDependencies.getFormElements(form);
    const params = EditFormDependencies.buildParams(elements);

    const loader = form.querySelector('.js-showing-view-time-loader');
    const toggleTimeLoader = (visible) => LayoutUtils.toggle(loader, visible);

    toggleTimeLoader(true);
    FetchUtils.fetchJSON(`${dependenciesUrl}?${params.toString()}`)
      .then((response) => EditFormDependencies.applyResponse(form, response, elements, callbacks))
      .catch((err) => FetchUtils.handleResponseError(err))
      .finally(() => toggleTimeLoader(false));
  }
}

export function getDependencyFormElements(form) {
  return EditFormDependencies.getFormElements(form);
}

export function buildDependenciesParams(elements) {
  return EditFormDependencies.buildParams(elements);
}

export function reloadEditDependencies(form, callbacks = {}) {
  EditFormDependencies.reload(form, callbacks);
}
